import useContract from "hooks/useContract";
import { abi as LayawayRouterAbi } from "constants/abis/layaway-router.abi.json";

export function useLayawayRouterContract() {
  return useContract(process.env.REACT_APP_LAYAWAY_ROUTER, LayawayRouterAbi);
}
